import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { loginWithPasskey } from '../../utils/webauthn.js';
import { useTenantAdminAuth } from '../../auth/TenantAdminAuthContext.jsx';
import { AuthLayout } from '../../components/layout/AuthLayout.jsx';

export function PasskeyLoginPage() {
  const { refresh } = useTenantAdminAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleClick() {
    setError(null);
    setSubmitting(true);
    try {
      await loginWithPasskey('tenant-admin');
      await refresh();
      navigate('/', { replace: true });
    } catch {
      setError('Passkey sign-in was cancelled or failed. You can also sign in with your password.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthLayout title="Sign in with a passkey" description="Use your device’s saved passkey for a quick, secure sign in." role="Restaurant admin" footer={<Link to="/login">Use your password instead</Link>}>
      {error && <p className="field-error" role="alert">{error}</p>}
      <button type="button" className="btn btn-primary auth-submit" onClick={handleClick} disabled={submitting}>
        {submitting ? 'Waiting for passkey…' : 'Continue with passkey'}
      </button>
    </AuthLayout>
  );
}
